import IconLogoDarkTheme from '@shared/icons/IconLogoDarkTheme';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useLogin } from '@app/queries/user/useLogin';
import { GrayButton } from '@shared/uikit/button';

const Login = () => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [invalid, setInvalid] = useState<boolean>(false);
  const [usernameInteractive, setUsernameInteractive] = useState(false);
  const [passwordInteractive, setPasswordInteractive] = useState(false);
  const navigate = useNavigate();

  const { login } = useLogin();

  const onLogin = async () => {
    try {
      const token = await login({ username, password });
      await localStorage.setItem('tokens', JSON.stringify({ access_token: token.access_token }));
    } catch (e) {
      setInvalid(true);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const returnURL = params.get('returnURL');

    if (!returnURL || returnURL === '/' || returnURL === '/home') {
      return navigate('/main');
    }

    setInvalid(false);
    return navigate('' + returnURL);
  };

  return (
    <div className="flex items-center justify-center h-full">
      <div>
        <div className="flex items-center justify-center gap-[10px] mb-[20px]">
          <div className="w-[130px] h-[33px]">
            <IconLogoDarkTheme />
          </div>
        </div>
        <div className="font-semibold text-4.90xl mb-[40px] text-center">
          Statistics database Neopool
        </div>
        <div className="text-center text-1xl font-medium mb-[20px]">Вход в систему</div>
        <form
          className="w-[70%] m-auto"
          autoComplete="off"
          onSubmit={event => {
            event.preventDefault();
            void onLogin();
          }}
        >
          <div
            className={`h-[33px] w-full rounded-[8px] px-[10px] flex items-center border border-solid mb-[20px] ${invalid ? 'border-[#E23336]' : 'border-[#2B292F]'} bg-[#141316]`}
          >
            <input
              className="outline-none w-full h-full bg-[#141316] text-white"
              type="email"
              name="username"
              autoComplete="username"
              readOnly={!usernameInteractive}
              onFocus={() => setUsernameInteractive(true)}
              placeholder="Email"
              value={username}
              onChange={event => setUsername(event.target.value)}
            />
          </div>
          <div
            className={`h-[33px] w-full rounded-[8px] px-[10px] flex items-center border border-solid mb-[20px] ${invalid ? 'border-[#E23336]' : 'border-[#2B292F]'} bg-[#141316]`}
          >
            <input
              className="outline-none w-full h-full bg-[#141316] text-white"
              type="password"
              name="password"
              autoComplete="current-password"
              readOnly={!passwordInteractive}
              onFocus={() => setPasswordInteractive(true)}
              placeholder="Пароль"
              value={password}
              onChange={event => setPassword(event.target.value)}
            />
          </div>
          <div className="mb-[20px]">
            <GrayButton title="Войти" type="submit" onClick={() => {}} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
